// import React, { useState } from "react";
// import "./HowItWorksV2.css";

// import step1 from "../../assets/how-works-image/step-011.png";
// import step2 from "../../assets/how-works-image/step-022.png";
// import step3 from "../../assets/how-works-image/step-03.jpg";
// import step4 from "../../assets/how-works-image/step-044.png";
// import step5 from "../../assets/how-works-image/step-55.png";
// import step6 from "../../assets/how-works-image/step-06.jpg";
// import step7 from "../../assets/how-works-image/step-07.jpg";

// const steps = [
//   {
//     n: "01",
//     title: "Understand",
//     short:
//       "We understand your lifestyle, space, requirements and budget.",
//     detail:
//       "We sit down with you — at home or on a call — to map how you actually live: routines, storage, light, who uses which room, and the budget you're comfortable with.",
//     outcome: "Brief & budget agreed",
//     img: step1,
//   },
//   {
//     n: "02",
//     title: "Design",
//     short:
//       "Our designers develop the complete interior concept and detailed design.",
//     detail:
//       "Our designers translate the brief into layouts, 3D views and a complete interior concept, refined with you until every room feels right.",
//     outcome: "3D concept & layouts",
//     img: step2,
//   },
//   {
//     n: "03",
//     title: "Finalise",
//     short:
//       "Materials, finishes, products, specifications and budget are finalised with you.",
//     detail:
//       "You see and touch the real materials. Finishes, hardware, products and specifications are locked, and the budget is confirmed line by line.",
//     outcome: "Specs & quote locked",
//     img: step3,
//   },
//   {
//     n: "04",
//     title: "Start On-Site Work",
//     short:
//       "With the design signed off, we onboard consultants and start civil and carpentry work on site.",
//     detail:
//       "Once designs are finalised, execution begins. We onboard the required consultants and site teams — civil work, carpentry and any structural changes — set up the site, and get the base work moving under Dwellora supervision.",
//     outcome: "Site mobilised & base work started",
//     img: step4,
//   },
//   {
//     n: "05",
//     title: "Match Specialists",
//     short:
//       "Each work package is assigned to the most suitable specialist manufacturer or team.",
//     detail:
//       "Joinery, stone, lighting, upholstery — each package goes to the specialist who does that one thing best, instead of one contractor doing everything.",
//     outcome: "Right maker per package",
//     img: step5,
//   },
//   {
//     n: "06",
//     title: "Coordinate",
//     short:
//       "Dwellora manages communication, timelines, quality and site execution.",
//     detail:
//       "One point of contact. We run the schedule, sequence deliveries, run quality checks on site and keep you updated at every milestone.",
//     outcome: "Single point of contact",
//     img: step6,
//   },
//   {
//     n: "07",
//     title: "Deliver",
//     short: "All components come together into one cohesive interior.",
//     detail:
//       "Installation, styling and a final walkthrough — everything comes together into one cohesive interior, handed over ready to live in.",
//     outcome: "Move-in ready handover",
//     img: step7,
//   },
// ];

// function PrevIcon() {
//   return (
//     <svg
//       width="16"
//       height="16"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="m12 19-7-7 7-7" />
//       <path d="M19 12H5" />
//     </svg>
//   );
// }

// function NextIcon() {
//   return (
//     <svg
//       width="16"
//       height="16"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M5 12h14" />
//       <path d="m12 5 7 7-7 7" />
//     </svg>
//   );
// }

// export default function HowItWorks() {
//   const [active, setActive] = useState(0);
//   const step = steps[active];
//   const fillWidth = (active / (steps.length - 1)) * 100;

//   const goPrev = () => setActive((a) => Math.max(0, a - 1));
//   const goNext = () => setActive((a) => Math.min(steps.length - 1, a + 1));

//   return (
//     <section className="section light" aria-labelledby="hiw">
//       <div className="wrap">
//         <header className="hdr">
//           <h2 id="hiw">How Dwellora works</h2>
//           <span className="caps">Seven steps</span>
//         </header>

//         <div className="stepper">
//           <div className="track" aria-hidden="true" />
//           <div
//             className="fill"
//             style={{ width: `${fillWidth}%` }}
//             aria-hidden="true"
//           />
//           <ol>
//             {steps.map((s, i) => (
//               <li key={s.n}>
//                 <button
//                   className={
//                     "dot" +
//                     (i === active ? " active" : "") +
//                     (i < active ? " done" : "")
//                   }
//                   onClick={() => setActive(i)}
//                   aria-label={s.title}
//                 >
//                   {i + 1}
//                 </button>
//                 <span className={"dot-label" + (i === active ? " on" : "")}>
//                   {s.title}
//                 </span>
//               </li>
//             ))}
//           </ol>
//         </div>

//         <div className="panel">
//           <div>
//             <span className="caps" style={{ color: "var(--glow)" }}>
//               Step <span>{step.n}</span>
//             </span>
//             <h3>{step.title}</h3>
//             <p className="detail">{step.detail}</p>
//             <p className="badge caps">
//               <i />
//               <span>{step.outcome}</span>
//             </p>
//             <div className="navs">
//               <button
//                 className="nav"
//                 onClick={goPrev}
//                 disabled={active === 0}
//                 aria-label="Previous step"
//               >
//                 <PrevIcon />
//               </button>
//               <button
//                 className="nav"
//                 onClick={goNext}
//                 disabled={active === steps.length - 1}
//                 aria-label="Next step"
//               >
//                 <NextIcon />
//               </button>
//             </div>
//           </div>
//           <figure>
//             <img
//               src={step.img}
//               alt={`Illustration for step ${step.n}: ${step.title}`}
//               width={1200}
//               height={900}
//             />
//           </figure>
//         </div>

//         <div className="grid">
//           {steps.map((s, i) => (
//             <button
//               key={s.n}
//               className={"card" + (i === active ? " active" : "")}
//               onClick={() => setActive(i)}
//             >
//               <img src={s.img} alt="" width={1200} height={900} />
//               <span className="card-n">{s.n}</span>
//               <span className="card-t">{s.title}</span>
//               <span className="card-s">{s.short}</span>
//             </button>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }





import React, { useState } from "react";
import "./HowItWorksV2.css";

import step1 from "../../assets/how-works-image/step-011.png";
import step2 from "../../assets/how-works-image/step-022.png";
import step3 from "../../assets/how-works-image/step-03.jpg";
import step4 from "../../assets/how-works-image/step-044.png";
import step5 from "../../assets/how-works-image/step-55.png";
import step6 from "../../assets/how-works-image/step-06.jpg";
import step7 from "../../assets/how-works-image/step-07.jpg";
import ctaIllustration from "../../assets/how-works-image/ChatGPT Image Sep 16, 2026, 02_19_30 PM.png";

const steps = [
  {
    n: "01",
    title: "Understand",
    short:
      "We understand your lifestyle, space, requirements and budget.",
    detail:
      "We sit down with you — at home or on a call — to map how you actually live: routines, storage, light, who uses which room, and the budget you're comfortable with.",
    outcome: "Brief & budget agreed",
    img: step1,
  },
  {
    n: "02",
    title: "Design",
    short:
      "Our designers develop the complete interior concept and detailed design.",
    detail:
      "Our designers translate the brief into layouts, 3D views and a complete interior concept, refined with you until every room feels right.",
    outcome: "3D concept & layouts",
    img: step2,
  },
  {
    n: "03",
    title: "Finalise",
    short:
      "Materials, finishes, products, specifications and budget are finalised with you.",
    detail:
      "You see and touch the real materials. Finishes, hardware, products and specifications are locked, and the budget is confirmed line by line.",
    outcome: "Specs & quote locked",
    img: step3,
  },
  {
    n: "04",
    title: "Start On-Site Work",
    short:
      "With the design signed off, we onboard consultants and start civil and carpentry work on site.",
    detail:
      "Once designs are finalised, execution begins. We onboard the required consultants and site teams — civil work, carpentry and any structural changes — set up the site, and get the base work moving under Dwellora supervision.",
    outcome: "Site mobilised & base work started",
    img: step4,
  },
  {
    n: "05",
    title: "Match Specialists",
    short:
      "Each work package is assigned to the most suitable specialist manufacturer or team.",
    detail:
      "Joinery, stone, lighting, upholstery — each package goes to the specialist who does that one thing best, instead of one contractor doing everything.",
    outcome: "Right maker per package",
    img: step5,
  },
  {
    n: "06",
    title: "Coordinate",
    short:
      "Dwellora manages communication, timelines, quality and site execution.",
    detail:
      "One point of contact. We run the schedule, sequence deliveries, run quality checks on site and keep you updated at every milestone.",
    outcome: "Single point of contact",
    img: step6,
  },
  {
    n: "07",
    title: "Deliver",
    short: "All components come together into one cohesive interior.",
    detail:
      "Installation, styling and a final walkthrough — everything comes together into one cohesive interior, handed over ready to live in.",
    outcome: "Move-in ready handover",
    img: step7,
  },
];

function PrevIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </svg>
  );
}

function NextIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  );
}

export default function HowItWorks() {
  const [active, setActive] = useState(0);
  const step = steps[active];
  const fillWidth = (active / (steps.length - 1)) * 100;

  const goPrev = () => setActive((a) => Math.max(0, a - 1));
  const goNext = () => setActive((a) => Math.min(steps.length - 1, a + 1));

  return (
    <section className="section light" aria-labelledby="hiw">
      <div className="wrap">
        <header className="hdr">
          <h2 id="hiw">How Dwellora works</h2>
          <span className="caps">Seven steps</span>
        </header>

        <div className="stepper">
          <div className="track" aria-hidden="true" />
          <div
            className="fill"
            style={{ width: `${fillWidth}%` }}
            aria-hidden="true"
          />
          <ol>
            {steps.map((s, i) => (
              <li key={s.n}>
                <button
                  className={
                    "dot" +
                    (i === active ? " active" : "") +
                    (i < active ? " done" : "")
                  }
                  onClick={() => setActive(i)}
                  aria-label={s.title}
                >
                  {i + 1}
                </button>
                <span className={"dot-label" + (i === active ? " on" : "")}>
                  {s.title}
                </span>
              </li>
            ))}
          </ol>
        </div>

        <div className="panel">
          <div>
            <span className="caps" style={{ color: "var(--glow)" }}>
              Step <span>{step.n}</span>
            </span>
            <h3>{step.title}</h3>
            <p className="detail">{step.detail}</p>
            <p className="badge caps">
              <i />
              <span>{step.outcome}</span>
            </p>
            <div className="navs">
              <button
                className="nav"
                onClick={goPrev}
                disabled={active === 0}
                aria-label="Previous step"
              >
                <PrevIcon />
              </button>
              <button
                className="nav"
                onClick={goNext}
                disabled={active === steps.length - 1}
                aria-label="Next step"
              >
                <NextIcon />
              </button>
            </div>
          </div>
          <figure>
            <img
              src={step.img}
              alt={`Illustration for step ${step.n}: ${step.title}`}
              width={1200}
              height={900}
            />
          </figure>
        </div>

        <div className="grid">
          {steps.map((s, i) => (
            <button
              key={s.n}
              className={"card" + (i === active ? " active" : "")}
              onClick={() => setActive(i)}
            >
              <img src={s.img} alt="" width={1200} height={900} />
              <span className="card-n">{s.n}</span>
              <span className="card-t">{s.title}</span>
              <span className="card-s">{s.short}</span>
            </button>
          ))}

          <div className="cta-card">
            <div className="cta-text">
              {/* <span className="cta-eyebrow caps">Free Consultation</span>
              <h3>Ready to begin?</h3>
              <p>
                A great interior starts with one conversation. Let&apos;s
                talk about your space.
              </p> */}

 <span className="cta-eyebrow caps">HAVE A PROJECT IN MIND?</span>
              <h3>Talk to a Designer</h3>
              <p>
               Get expert guidance, share your ideas and find the right solution for your space.
              </p>

              {/* <button className="cta-btn">
                <span>Talk to a Designer</span>
                <NextIcon />
              </button> */}

 <button
                className="cta-btn"
                type="button"
                onClick={() => {
                  window.dispatchEvent(new CustomEvent("dwellora:open-contact"));
                }}
              >
                <span>Talk to a Designer</span>
                <NextIcon />
              </button>

            </div>
            <div className="cta-visual">
              <img
                className="cta-illustration"
                src={ctaIllustration}
                alt="Designer pointing, ready to help with your project"
                width={1536}
                height={1024}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
